import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DesignEditorPrimaryControlButton from '../../../../../DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';
import BackgroundIcon from '../../../../../../icons/BackgroundIcon';

const propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const CardDesignerBackgroundControlsButton = ({
  className,
  onClick,
  active,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControlButton
      className={classes}
      active={active}
      icon={<BackgroundIcon />}
      title="Background"
      onClick={onClick}
    />
  );
};

CardDesignerBackgroundControlsButton.propTypes = propTypes;

export default CardDesignerBackgroundControlsButton;
